import { render } from "./TheDoiTheThaoThanhTich.vue?vue&type=template&id=3588d62e"
import script from "./TheDoiTheThaoThanhTich.vue?vue&type=script&lang=js"
export * from "./TheDoiTheThaoThanhTich.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__